import React from 'react';
import { Box, Container, Paper, Typography } from '@mui/material';
import { layoutPaddingY } from './layoutSpacing';

const SetupLayout = ({ title, children }) => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f7fb', py: layoutPaddingY }}>
      <Container maxWidth="md">
        <Paper elevation={2} sx={{ p: { xs: 3, sm: 4 }, borderRadius: 2 }}>
          {title && (
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 3, color: '#1a3a5c' }}>
              {title}
            </Typography>
          )}
          {children}
        </Paper>
      </Container>
    </Box>
  );
};

export default SetupLayout;
